export default __webpack_public_path__ + "static/media/bronwyn_king.8d3798c1.jpg";